import { GlobalAppState } from '@model/state';

export const getTourDossiers = (state: GlobalAppState) => {
  return state.tours.tourDossiers.data;
};
export const getTourDossiersLoading = (state: GlobalAppState) => {
  return state.tours.tourDossiers.loading;
};
